import React from 'react'
import { useState } from 'react'
import GetHtmlStrLocalized from '../../datas/GetHtmlStrLocalized'
import Modal, { ModalBody, ModalFooter, ModalHeader } from './Modal'

interface LinkToModalProps {
    language: string;
    linkContent: string;
    isDarkTheme: boolean;
    children: React.ReactNode;
}


function LinkToModal({ language, linkContent, isDarkTheme, children }: Readonly<LinkToModalProps>) {
    const [showModal, setShowModal] = useState(false);

    return (
        <React.Fragment>
            <button className="btn" onClick={() => setShowModal(true)}>
                {linkContent}
            </button>
            <Modal
                language={language}
                show={showModal}
                setShow={setShowModal}
                isDarkTheme={isDarkTheme}
            >
                <ModalHeader>
                    <h3>{linkContent}</h3>
                </ModalHeader>
                <ModalBody>
                    {children}
                </ModalBody>
                <br />
                <ModalFooter>
                    <button onClick={() => setShowModal(false)}>
                        <GetHtmlStrLocalized language={language} textId="close" />
                    </button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}

export default LinkToModal;